import React from 'react';
import { GEOMETRY_TYPES } from './GeometrySelector';
import Accordion from './Accordion';

function GeometryForm({ params, onChange, geometryType }) {
  const handleChange = (field, value) => {
    onChange({ ...params, [field]: parseFloat(value) || 0 });
  };

  return (
    <div className="form-section">
      <Accordion title="Scan" defaultOpen={true}>
        <div className="form-group">
          <label>Source-to-Object Distance (mm)</label>
          <input
            type="number"
            min="0.1"
            step="0.1"
            value={params.sod}
            onChange={(e) => handleChange('sod', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Object-to-Detector Distance (mm)</label>
          <input
            type="number"
            min={params.sod + 0.1}
            step="0.1"
            value={params.odd}
            onChange={(e) => handleChange('odd', e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Detector Width (px)</label>
            <input
              type="number"
              min="1"
              step="1"
              value={params.detectorWidth}
              onChange={(e) => handleChange('detectorWidth', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Detector Height (px)</label>
            <input
              type="number"
              min="1"
              step="1"
              value={params.detectorHeight}
              onChange={(e) => handleChange('detectorHeight', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Detector Pitch (mm)</label>
          <input
            type="number"
            min="0.001"
            step="0.001"
            value={params.pitch}
            onChange={(e) => handleChange('pitch', e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Offset-X (px)</label>
            <input
              type="number"
              step="1"
              value={params.offsetX}
              onChange={(e) => handleChange('offsetX', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Offset-Y (px)</label>
            <input
              type="number"
              step="1"
              value={params.offsetY}
              onChange={(e) => handleChange('offsetY', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Number of Scans</label>
          <input
            type="number"
            min="1"
            step="1"
            value={params.numScans}
            onChange={(e) => handleChange('numScans', e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Start Angle (deg)</label>
            <input
              type="number"
              min="0"
              max="360"
              step="1"
              value={params.startAngle}
              onChange={(e) => handleChange('startAngle', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>End Angle (deg)</label>
            <input
              type="number"
              min="0"
              max="360"
              step="1"
              value={params.endAngle}
              onChange={(e) => handleChange('endAngle', e.target.value)}
            />
          </div>
        </div>

        {geometryType !== GEOMETRY_TYPES.TOMOGRAPHY && (
          <div className="form-group">
            <label>Tilt X (deg)</label>
            <div style={{display:"flex", flexDirection: "column", gap: "8px"}}>
              <input
                type="number"
                min="0"
                max="90"
                step="1"
                value={params.tilt}
                onChange={(e) => handleChange('tilt', e.target.value)}
              />
              {geometryType === GEOMETRY_TYPES.INCLINED_LAMINOGRAPHY && (
                <label style={{ fontSize: "11px" }}>Note: Set angle to 90° for CT geometry</label>
              )}
            </div>
          </div>
        )}

        {(geometryType === GEOMETRY_TYPES.INCLINED_LAMINOGRAPHY ||
          geometryType === GEOMETRY_TYPES.GIMBAL_LOCK_LAMINOGRAPHY) && (
          <div className="form-group">
            <label>Tilt Y (deg)</label>
            <input
              type="number"
              min="-90"
              max="90"
              step="1"
              value={params.tiltY}
              onChange={(e) => handleChange('tiltY', e.target.value)}
            />
          </div>
        )}
      </Accordion>
    </div>
  );
}

export default GeometryForm;
